<template>
    <a-modal :title="state.modalTitle" :width="1200" :open="true" @ok="onFormSubmit" :confirmLoading="state.loading"
        @cancel="
            () => {
                emit('cancel')
            }
        ">
        <template #footer>
            <a-button size="middle" @click="
                () => {
                    emit('cancel')
                }
            ">取消</a-button>

            <a-button size="middle" type="primary" @click="onFormSubmit()" :loading="state.finishLoading"
                :disabled="state.finishLoading">确定</a-button>
        </template>
        <a-spin :spinning="loading">
            <a-form ref="formRef" v-bind="formLayout" :model="formState" :rules="rules">
                <a-row>
                    <a-col :span="12">
                        <a-form-item required label="工单标题" name="title">
                            <a-input v-model:value="formState.title" placeholder="请输入工单标题"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="紧急情况">
                            <a-radio-group button-style="solid" v-model:value="formState.critical_situation">
                                <a-radio-button :value="1">不急</a-radio-button>
                                <a-radio-button :value="2">普通</a-radio-button>
                                <a-radio-button :value="3">紧急</a-radio-button>
                                <a-radio-button :value="4">最高级</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="工单类型（大类）" name="type">
                            <a-radio-group v-model:value="formState.type" button-style="solid" @change="change">
                                <a-radio-button :value="3">代办事项</a-radio-button>
                                <a-radio-button :value="1">投诉</a-radio-button>
                                <a-radio-button :value="2">举报</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="工单类型（小类）" required>
                            <a-row :gutter="8">
                                <a-col :span="16">
                                    <a-select allow-clear ref="select" v-model:value="formState.wo_type"
                                        style="width: 100%;">
                                        <a-select-option :value="1"
                                            v-if="formState.type == 1 || formState.type == 2">经营纠纷</a-select-option>
                                        <a-select-option :value="2"
                                            v-if="formState.type == 1 || formState.type == 2">网络卖课</a-select-option>
                                        <a-select-option :value="3"
                                            v-if="formState.type == 1 || formState.type == 2">疑似诈骗</a-select-option>
                                        <a-select-option :value="4"
                                            v-if="formState.type == 1 || formState.type == 2">疑似银行类犯罪</a-select-option>
                                        <a-select-option :value="6"
                                            v-if="formState.type == 1 || formState.type == 2">虚假宣传</a-select-option>
                                        <a-select-option :value="7"
                                            v-if="formState.type != 1 && formState.type != 2">主体信息变动尽调</a-select-option>
                                        <a-select-option :value="8"
                                            v-if="formState.type != 1 && formState.type != 2">收到执照、章</a-select-option>
                                        <a-select-option :value="9"
                                            v-if="formState.type != 1 && formState.type != 2">收到包裹</a-select-option>
                                        <a-select-option :value="10"
                                            v-if="formState.type != 1 && formState.type != 2">申报异常</a-select-option>
                                        <a-select-option :value="11"
                                            v-if="formState.type != 1 && formState.type != 2">移出异常</a-select-option>
                                        <a-select-option :value="12"
                                            v-if="formState.type != 1 && formState.type != 2">日常管理巡查</a-select-option>
                                        <a-select-option :value="13"
                                            v-if="formState.type != 1 && formState.type != 2">风控电话</a-select-option>
                                        <a-select-option :value="5">其他</a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :span="8" style="display: flex; align-items: center; gap: 4px;">
                                    <span
                                        style="color: rgba(0,0,0,0.45); font-size: 12px; white-space: nowrap;">快捷输入</span>
                                    <a-button size="small"
                                        style="color: #389e0d; background: #f6ffed; border-color: #b7eb8f;"
                                        @click="handleQuickFengkong">
                                        风控核实
                                    </a-button>
                                </a-col>
                            </a-row>
                            <!-- 其他具体名称输入框 -->
                            <a-form-item required label="" name="wo_type_son" v-if="formState.wo_type == 5"
                                :labelCol="{ span: 0 }" :wrapperCol="{ span: 24 }"
                                style="margin-top: 8px; margin-bottom: 0;">
                                <a-input v-model:value="formState.wo_type_son" placeholder="请输入其他具体名称"></a-input>
                            </a-form-item>
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row>
                    <a-col :span="12">
                        <a-form-item required label="信息来源情况" name="source">
                            <a-input v-model:value="formState.source" placeholder="请输入信息来源情况"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="工单服务对象" v-if="state.isEdit" required>
                            {{ formState.customer_info['full_name'] }}
                        </a-form-item>
                        <a-form-item label="工单服务对象" v-if="!state.isEdit" name="customer_ids" required>
                            <SelectCompany :isEdit="false" :selectCheck="formState.customer_ids"
                                @change="SelectCompanyChange" listType="gongdan">
                            </SelectCompany>
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row>
                    <a-col :span="12">
                        <a-form-item label="归属销售" name="reception_admin_ids" required>
                            <UserPick v-model:value="formState.reception_admin_ids" mode="multiple"
                                placeholder="请输入归属销售姓名或手机号码" v-if="formState.customer_ids.length <= 1">
                            </UserPick>
                            <span v-else>自动根据主体名称自动匹配</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="工单执行负责人" name="custodian_admin_ids" required>
                            <UserPick v-model:value="formState.custodian_admin_ids" mode="multiple"
                                placeholder="请输入工单执行负责人姓名或手机号码">
                            </UserPick>
                        </a-form-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-item label="开始时间" name="start_time" required>
                            <a-date-picker :show-time="{ defaultValue: arrayMonent }"
                                v-model:value="formState.start_time" placeholder="请选择开始日期"></a-date-picker>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="截止完成时间" name="end_time" required>
                            <a-date-picker :show-time="{ defaultValue: arrayMonent }" v-model:value="formState.end_time"
                                placeholder="请选择截止日期"></a-date-picker>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="工单内容" name="content">
                            <a-textarea :rows="3" placeholder="请输入工单内容" v-model:value="formState.content"> </a-textarea>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="机密内容">
                            <a-textarea placeholder="请输入机密内容" v-model:value="formState.secret_content" :rows="3">
                            </a-textarea>
                        </a-form-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-item :label="(formState.type == 1 ? '投诉' : '举报') + '人姓名'" name="tousu_name"
                            v-if="formState.type == 1 || formState.type == 2">
                            <a-input v-model:value="formState.tousu_name"
                                :placeholder="'请输入' + (formState.type == 1 ? '投诉人' : '举报人') + '姓名'"
                                @change="titleformat"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item :label="(formState.type == 1 ? '投诉' : '举报') + '人电话'" name="tousu_tel"
                            v-if="formState.type == 1 || formState.type == 2">
                            <a-input v-model:value="formState.tousu_tel"
                                :placeholder="'请输入' + (formState.type == 1 ? '投诉人' : '举报人') + '电话'"
                                @change="titleformat"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="附件">
                            <Upload
                                :upload_path="props.counterfeitInfo ? props.counterfeitInfo.upload_path : `public/uploads/manage/工单/${dayjs().format('YYYYMM')}/`"
                                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']"
                                v-model:value="formState.attachment" uploadType="text" :limitation="9"
                                uploadText="上传附件">
                            </Upload>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="涉及金额" name="tousu_money" v-if="formState.type == 1 || formState.type == 2">
                            <a-input v-model:value="formState.tousu_money" placeholder="请输入涉及金额" @change="titleformat"
                                prefix="￥" suffix="元"></a-input>
                        </a-form-item>
                    </a-col>

                    <!-- 新增扣款考核字段 -->
                    <a-col :span="12">
                        <a-form-item label="参加扣款考核" name="is_deduction">
                            <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.is_deduction"
                                checked-children="参加" un-checked-children="不参加" @change="onDeductionChange"></a-switch>
                        </a-form-item>
                    </a-col>
                    <template v-if="formState.is_deduction == 1">
                        <a-col :span="12">
                            <a-form-item label="允许延期次数" name="allow_defer_count" required>
                                <a-input-number v-model:value="formState.allow_defer_count" placeholder="请输入允许延期次数"
                                    :min="0" :max="10" style="width: 100%" />
                                <span style="color: #999; font-size: 12px; margin-left: 8px;">
                                    延期第一次扣款时间
                                </span>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="不理扣款截止时间" name="first_deduction_time" required>
                                <a-date-picker :show-time="{ defaultValue: dayjs('10:00:00', 'HH:mm:ss') }"
                                    v-model:value="formState.first_deduction_time" placeholder="请选择不理扣款截止时间"
                                    :disabled-date="disabledDate" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="不理扣款金额" name="first_deduction_amount" required>
                                <a-input-number v-model:value="formState.first_deduction_amount" placeholder="请输入不理扣款金额"
                                    :min="0" :precision="2" style="width: 100%" prefix="￥" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="超期后每24小时扣款金额" name="subsequent_deduction_amount" required>
                                <a-input-number v-model:value="formState.subsequent_deduction_amount"
                                    placeholder="请输入后续每24小时扣款金额" :min="0" :precision="2" style="width: 100%"
                                    prefix="￥" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="封顶扣款金额" name="max_deduction_amount" required>
                                <a-input-number v-model:value="formState.max_deduction_amount" placeholder="请输入封顶扣款金额"
                                    :min="0" :precision="2" style="width: 100%" prefix="￥" />
                            </a-form-item>
                        </a-col>
                    </template>
                </a-row>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup>
import cloneDeep from 'lodash.clonedeep'
import { Upload, SelectCompany } from '@/components'
import baseService from '@/utils/http/axios'
import { message } from 'ant-design-vue'
import { ref, reactive, onMounted, watch } from 'vue'
import UserPick from '@/components/base/UserPick.vue'
import { debounce } from 'lodash-es'
import dayjs from 'dayjs'
import { platform } from 'os'

const emit = defineEmits(['cancel', 'ok'])
const arrayMonent = dayjs('00:00:00', 'HH:mm:ss')
const format = 'YYYY-MM-DD HH:mm:ss'
const startTime = dayjs()
const endTime = dayjs().add(1, 'day')

// 禁用日期（不允许选择过去的时间）
const disabledDate = (current: any) => {
    return current && current < dayjs().startOf('day')
}

// 快捷操作：风控核实
const handleQuickFengkong = () => {
    // 切换大类为代办事项
    formState.type = 3
    // 小类设为风控电话（13）
    formState.wo_type = 13
    // 设置标题
    formState.title = '风控核实电话未通过，请联系负责人接听电话'
    // 设置工单内容
    formState.content = '风控核实电话不通过，请联系负责人接听电话，风控核实未完成，如为包注册服务，该笔订单的进度将自动停止，如未出裸地址的订单，请联系渠道，完成风控核实后再次提交'
    // 信息来源改为办公室
    formState.source = '办公室'
    // 紧急情况改为普通
    formState.critical_situation = 2
}

const rules = {
    type: [
        {
            required: true,
            message: '请选择工单类型'
        }
    ],
    content: [
        {
            required: false,
            message: '请输入工单内容'
        }
    ],
    // 添加工单服务对象的验证
    customer_ids: [
        {
            required: true,
            message: '请选择工单服务对象',
            validator: (rule: any, value: any[]) => {
                if (!value || value.length === 0) {
                    return Promise.reject('请选择工单服务对象')
                }
                return Promise.resolve()
            }
        }
    ],
    // 新增扣款考核验证
    allow_defer_count: [
        {
            required: true,
            message: '请输入允许延期次数',
            validator: (rule: any, value: any) => {
                if (formState.is_deduction == 1 && (value === null || value === undefined)) {
                    return Promise.reject('请输入允许延期次数')
                }
                return Promise.resolve()
            }
        }
    ],
    first_deduction_time: [
        {
            required: true,
            message: '请选择第一次扣款时间',
            validator: (rule: any, value: any) => {
                if (formState.is_deduction == 1 && !value) {
                    return Promise.reject('请选择第一次扣款时间')
                }
                return Promise.resolve()
            }
        }
    ],
    first_deduction_amount: [
        {
            required: true,
            message: '请输入第一次扣款金额',
            validator: (rule: any, value: any) => {
                if (formState.is_deduction == 1 && (!value && value !== 0)) {
                    return Promise.reject('请输入第一次扣款金额')
                }
                return Promise.resolve()
            }
        }
    ],
    subsequent_deduction_amount: [
        {
            required: true,
            message: '请输入后续每24小时扣款金额',
            validator: (rule: any, value: any) => {
                if (formState.is_deduction == 1 && (!value && value !== 0)) {
                    return Promise.reject('请输入后续每24小时扣款金额')
                }
                return Promise.resolve()
            }
        }
    ],
    max_deduction_amount: [
        {
            required: true,
            message: '请输入封顶扣款金额',
            validator: (rule: any, value: any) => {
                if (formState.is_deduction == 1 && (!value && value !== 0)) {
                    return Promise.reject('请输入封顶扣款金额')
                }
                return Promise.resolve()
            }
        }
    ]
}

interface formState {
    title: string
    source: string
    customer_info: object
    type: number
    wo_type: number | null
    customer_ids: any[]
    start_time: any
    end_time: any
    content: string
    custodian_admin_ids: any[]
    reception_admin_ids: any[]
    secret_content: string
    attachment: any[]
    critical_situation: number
    wo_type_son: string
    tousu_name: string | null
    tousu_tel: string | null
    tousu_money: string | null
    // 新增扣款考核字段
    is_deduction: number          // 是否参加扣款考核
    allow_defer_count: number | null // 允许延期次数
    first_deduction_time: any      // 第一次扣款时间
    first_deduction_amount: number | null // 第一次扣款金额
    subsequent_deduction_amount: number | null // 后续每24小时扣款金额
    max_deduction_amount: number | null // 封顶扣款金额
}

// 根据工单类型获取允许延期次数的默认值
const getDefaultDeferCount = (type: number) => {
    // 举报类工单允许延期1次
    if (type === 2) {
        return 1
    }
    // 非举报类工单（投诉、代办事项）允许延期2次
    return 2
}

const formState = reactive<formState>({
    title: '有投诉，请及时处理',
    source: '12345或工商所',
    customer_info: [],
    type: 1,
    wo_type: 1,
    customer_ids: [],
    critical_situation: 2,
    end_time: dayjs().subtract(-2, 'day'),
    start_time: startTime,
    content: '',
    custodian_admin_ids: [],
    reception_admin_ids: [],
    secret_content: '',
    attachment: [],
    wo_type_son: '',
    tousu_name: '',
    tousu_tel: '',
    tousu_money: '',
    // 新增扣款考核默认值
    is_deduction: 2,
    allow_defer_count: 2, // 默认2次（非举报类）
    first_deduction_time: dayjs().add(2, 'day').hour(10).minute(0).second(0),
    first_deduction_amount: 20,   // 默认20元
    subsequent_deduction_amount: 5, // 默认5元
    max_deduction_amount: 100    // 默认100元
})

const props = defineProps({
    detailData: {
        type: Object
    },
    loading: {
        type: Boolean,
        default: () => false
    },
    model: {
        type: Object,
        default: () => null
    },
    counterfeitInfo: {
        type: Object,
        default: () => null
    }
})

const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
    }
}

onMounted(() => {
    if (props.detailData?.id) {
        state.isEdit = true
        state.modalTitle = '编辑工单'
        queryDetail(props.detailData.id)
    }
    if (props.counterfeitInfo) {
        formState.customer_ids.push({ id: props.counterfeitInfo.customer_id, name: props.counterfeitInfo.full_name })
        formState.reception_admin_ids.push(props.counterfeitInfo.seller_id)
        //获取平台的异常投诉专员
        let requestParam = {
            url: '/admin/v1/workOrder/getPlatformYctsAdmin',
            method: 'post',
            data: {
                platform_id: props.counterfeitInfo.platform_id
            }
        }
        baseService(requestParam)
            .then((res: any) => {
                formState.custodian_admin_ids = res.data
            })
            .catch((res) => { })
    }
})

const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/workOrder/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam).then((res) => {
        state.loading = false
        res.data.end_time = dayjs(res.data.end_time, format)
        res.data.start_time = dayjs(res.data.start_time, format)

        // 处理扣款时间回显
        if (res.data.first_deduction_time) {
            res.data.first_deduction_time = dayjs(res.data.first_deduction_time, format)
        }

        Object.assign(formState, res.data)
    })
}

const formRef = ref()
const state = reactive<any>({
    loading: false,
    isEdit: false,
    modalTitle: '新增工单',
    userList: [],
    finishLoading: false
})

const SelectCompanyChange = (val: any[]) => {
    formState.customer_ids = val.map((res) => {
        return { id: res.id, name: res.name, seller_id: res.seller_id }
    })
    //归属代理商
    if (formState.customer_ids.length == 1) {
        formState.reception_admin_ids = [formState.customer_ids[0].seller_id]
    }
}

const change = (val) => {
    const type = val.target.value
    if (type == 1) {
        formState.critical_situation = 3
        formState.wo_type = 1
        formState.source = '12345或工商所'
        // 投诉类工单允许延期2次
        if (formState.is_deduction == 1) {
            formState.allow_defer_count = 2
        }
        // 如果标题是"有投诉，请及时处理"，保持不变
        if (!formState.title || formState.title === '有投诉，请及时处理') {
            // 保持默认标题
        }
    } else if (type == 2) {
        formState.critical_situation = 4
        formState.wo_type = 1
        formState.source = '12345或工商所'
        // 举报类工单允许延期1次
        if (formState.is_deduction == 1) {
            formState.allow_defer_count = 1
        }
    } else {
        formState.critical_situation = 2
        formState.wo_type = null
        formState.source = '办公室'
        // 代办事项类工单允许延期2次
        if (formState.is_deduction == 1) {
            formState.allow_defer_count = 2
        }
        // 点击代办事项时，如果标题等于"有投诉，请及时处理"则置空
        if (formState.title === '有投诉，请及时处理') {
            formState.title = ''
        }
    }
    if (!formState.title) {
        if (formState.type == 1 || formState.type == 2) {
            let namePart = '';
            if (formState.tousu_name || formState.tousu_tel) {
                const name = formState.tousu_name || '';
                const tel = formState.tousu_tel ? ' ' + formState.tousu_tel : '';
                namePart = '【' + name + tel + '】';
            }
            formState.title = namePart + typeMap.get(formState.type) + (formState.tousu_money ? '，涉及金额【' + formState.tousu_money + '元】' : '') + '，请及时处理'
        } else {
            formState.title = props.counterfeitInfo?.full_name ? props.counterfeitInfo.full_name + '有' + typeMap.get(formState.type) + '，请及时处理' : ''
        }
    }
}

// 监听小类变化，如果选择了风控电话则自动填充标题和内容
watch(() => formState.wo_type, (newVal) => {
    if (newVal === 13) {
        // 只有标题为空或者是默认标题时才自动填充
        if (!formState.title || formState.title === '有投诉，请及时处理' || formState.title === '') {
            formState.title = '风控核实电话未通过，请联系负责人接听电话'
        }
        if (!formState.content) {
            formState.content = '风控核实电话不通过，请联系负责人接听电话，风控核实未完成，如为包注册服务，该笔订单的进度将自动停止，如未出裸地址的订单，请联系渠道，完成风控核实后再次提交'
        }
        // 确保大类是代办事项
        if (formState.type !== 3) {
            formState.type = 3
        }
        formState.source = '办公室'
        formState.critical_situation = 2
    }
})

// 扣款考核开关变化处理
const onDeductionChange = (checked: boolean) => {
    if (checked) {
        // 开启时根据工单类型设置允许延期次数的默认值
        const deferCount = getDefaultDeferCount(formState.type)
        formState.allow_defer_count = deferCount
        formState.first_deduction_time = dayjs().add(2, 'day').hour(10).minute(0).second(0)
        formState.first_deduction_amount = 20
        formState.subsequent_deduction_amount = 5
        formState.max_deduction_amount = 100
    } else {
        // 关闭时清空值
        formState.allow_defer_count = null
        formState.first_deduction_time = null
        formState.first_deduction_amount = null
        formState.subsequent_deduction_amount = null
        formState.max_deduction_amount = null
    }
}

const onFormSubmit = () => {
    formRef.value
        .validate()
        .then((errors, values) => {
            let data = cloneDeep(formState)
            data.start_time = dayjs(data.start_time).format(format)
            data.end_time = dayjs(data.end_time).format(format)

            // 格式化扣款时间
            if (data.is_deduction == 1 && data.first_deduction_time) {
                data.first_deduction_time = dayjs(data.first_deduction_time).format(format)
            } else {
                data.first_deduction_time = null
            }

            if (props.detailData?.id) {
                let requeryParam = {
                    url: '/admin/v1/workOrder/' + props.detailData.id,
                    method: 'put',
                    data: data
                }
                state.loading = true
                state.finishLoading = true
                baseService(requeryParam)
                    .then((res: any) => {
                        message.success(res.msg)
                        emit('ok')
                        state.loading = false
                        state.finishLoading = false
                    })
                    .catch((res) => {
                        state.loading = false
                        state.finishLoading = false
                        message.warning(res.msg)
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/workOrder',
                    method: 'post',
                    data: data
                }
                state.loading = true
                state.finishLoading = true
                baseService(requeryParam)
                    .then((res: any) => {
                        message.success(res.msg)
                        emit('ok')
                        state.loading = false
                        state.finishLoading = false
                    })
                    .catch((res) => {
                        state.loading = false
                        state.finishLoading = false
                        message.warning(res.msg)
                    })
            }
        })
        .catch((res) => {
            message.warning('请检查表单必填项')
        })
}

const typeMap = new Map([
    [1, '投诉'],
    [2, '举报'],
    [3, '代办事项']
])

const titleformat = () => {
    if (state.isEdit == false) {
        if (formState.type == 1 || formState.type == 2) {
            let nameTelPart = '';
            if (formState.tousu_name || formState.tousu_tel) {
                if (formState.tousu_name && formState.tousu_tel) {
                    nameTelPart = '【' + formState.tousu_name + ' ' + formState.tousu_tel + '】';
                } else if (formState.tousu_name) {
                    nameTelPart = '【' + formState.tousu_name + '】';
                } else if (formState.tousu_tel) {
                    nameTelPart = '【' + formState.tousu_tel + '】';
                }
            }

            const moneyPart = formState.tousu_money ? '，涉及金额【' + formState.tousu_money + '元】' : '';
            formState.title = nameTelPart + typeMap.get(formState.type) + moneyPart + '，请及时处理';
        } else {
            formState.title = props.counterfeitInfo?.full_name ? props.counterfeitInfo.full_name + '有' + typeMap.get(formState.type) + '，请及时处理' : '';
        }
    }
}
</script>

<style lang="less" scoped>
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

.add-button {
    position: absolute;
    right: 65px;
    top: 10px;
}

.positionItem {
    display: inline-block;
    margin-bottom: 10px;
}
</style>
